const getPullingCredit = (state) => state.creditFreeze.pullingCredit;

const getCreditReportFailure = (state) => state.creditFreeze.creditReportFailure;

const getCreditReportSuccess = (state) => state.creditFreeze.creditReportSuccess;

const getCode = (state) => state.creditFreeze.code;

const getReportError = (state) => state.creditFreeze.error;

export default {
    getPullingCredit,
    getCreditReportFailure,
    getCreditReportSuccess,
    getCode,
    getReportError
};
